mutation UpdateUser(
  $userId: ID!
  $permissionIds: [ID!]
  $salesforceId: String
  $fullTitleOverride: String
  $password: PasswordChange
  $featureFlagsChanges: [FeatureFlagChangeInput!]
  $memberPageVisibility: Boolean
  $firstName: String
  $surname: String
  $bio: String
  $quote: String
  $displayPriority: Int
) {
  updateUser(
    input: {
      userId: $userId
      permissionIds: $permissionIds
      salesforceId: $salesforceId
      fullTitleOverride: $fullTitleOverride
      password: $password
      featureFlagsChanges: $featureFlagsChanges
      memberPageVisibility: $memberPageVisibility
      firstName: $firstName
      surname: $surname
      bio: $bio
      quote: $quote
      displayPriority: $displayPriority
    }
  ) {
    user {
      id
      permissions
      salesforceId
      featureFlags
      memberPageVisibility
      firstName
      surname
      bio
      quote
      displayPriority
    }
  }
}
